import { round, roundUp } from "../utils";

type Params = {
  cost: number;
  marginPrice: number;
};

export const COST_PRECISION = 2;

export const adaptComputedCost = ({
  cost,
  marginPrice,
}: Params): {
  cost: number;
  marginPrice: number;
  price: number;
} => {
  /* Due to the limitations of floating-point representation,
 rounding errors may occur during calculations,
 leading to undesired decimals. To ensure a final value
 rounded to the nearest higher integer, we use the round() function
 with precision up to 8 decimal places before applying the roundUp() function. */

  const sanitizedCost = roundUp(round(cost || 0, 8), COST_PRECISION);
  const sanitizedMarginPrice = roundUp(round(marginPrice || 0, 8), COST_PRECISION);
  const sanitizedPrice = sanitizedCost + sanitizedMarginPrice;

  return {
    cost: sanitizedCost,
    marginPrice: sanitizedMarginPrice,
    price: sanitizedPrice,
  };
};
